import { TextInput } from "react-admin";
import { alphanumericWordsValidator } from "../../validators";

export const TeamForm = () => (
	<TextInput source="name" validate={alphanumericWordsValidator} fullWidth />
);
